var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 0.833,
    y: 1,
    fill: "#FDFDFD",
    rx: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 0.833,
    y: 1,
    stroke: "#DCDCDE",
    strokeDasharray: "1 3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7F7D83",
    strokeLinecap: "round",
    d: "M9.833 7v6m3-3h-6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon3);
export default __webpack_public_path__ + "static/media/plus-icon-3.7ad82b30ac652d4c5c350c532bba0456.svg";
export { ForwardRef as ReactComponent };